import Marionette from "backbone.marionette";
import Components from "../../../utils/components";

const DEFAULTS = {
  tagName: "li",
  className: "options-wrapper bound",
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // generate components
    const components = Components.generate(this.model.toJSON());

    // set our template
    this.template = _.template(components);
  }
}

export { View as default };
